module.exports = __webpack_public_path__ + "static/media/slideshow-49.893b599c.jpeg";